const DYNAMIC_BG_CLASS_NAME = 'data-dynamic-bg';

const swapImage = (target) => {
  const targetSrc = target.getAttribute(DYNAMIC_BG_CLASS_NAME);
  target.style.backgroundImage = `url(${targetSrc})`;
  target.removeAttribute(DYNAMIC_BG_CLASS_NAME);
};

const dynamicImage = (images) => {
  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        swapImage(target);
        observer.unobserve(target);
      }
    });
  });

  images.forEach((image) => intersectionObserver.observe(image));
};

// polyfill
const injectImage = (images) => {
  [...images].forEach((image) => swapImage(image));
};

export const InitDynamicImage = () => {
  const dynamicBg = document.querySelectorAll(`[${DYNAMIC_BG_CLASS_NAME}]`);

  window.addEventListener('DOMContentLoaded', () => {
    dynamicBg && window.IntersectionObserver ? dynamicImage(dynamicBg) : injectImage(dynamicBg);
  });
};
